<template>
  <div>    
      <div v-if="!discoverMode || isMobile">
        <SearchForm/>
        <SearchFilter/>
      </div>
      <Grids/>
  </div>
</template>

<script>
import $ from "webpack-zepto";

import SearchForm from "../components/SearchForm";
import SearchFilter from "../components/SearchFilter";
import Grids from "../components/Grids";

const $mobileSearchButton = $("[data-behavior='vue-search-app__mobile-search-button']");

export default {
  name: "Home",
  components: {
    SearchForm,
    SearchFilter,
    Grids,
  },
  data: function () {
    return {
      isMobile: false,
    }
  },
  computed: {     
      discoverMode: function() {
        return this.$store.state.discoverMode;
      },             
  },
  methods: {
      mobileSearchButtonEventHandler() {
        // click event handler for the mobile search button
        // Displays (Activate) the search app
        $mobileSearchButton.on("click", (e) => {
          event.preventDefault();
          this.isMobile = true;
          $(document).trigger('SearchAppActivated', [e]);
        });        
      }
  },
  created() {
    // execute methods
    this.mobileSearchButtonEventHandler();
  }  
};
</script>